document.addEventListener('DOMContentLoaded', () => {
    $(".product_block").css("height", $(".product_block").outerHeight());
  

    // 产品变体选择加购
    var optionsList = []
    var url = ''
    var id = ''
    var state = ''

    // 类型为 button
    $('.product-card-wrapper variant-selects .pro-option').click(function(){

        if ($(this).hasClass('not-buy')) {
            $(this).parents('.product-card-wrapper').find('.product-form__submit').css('display', 'none')
            $(this).parents('.product-card-wrapper').find('.klaviyo-product-container').addClass('btn-show')
        } else {

            $(this).parents('.product-card-wrapper').find('.product-form__submit').css('display', 'block')
            $(this).parents('.product-card-wrapper').find('.klaviyo-product-container').removeClass('btn-show')

            optionsList = []
            
            $(this).siblings('.pro-option').removeClass('selected')
            $(this).addClass('selected')
            
            $(this).parents('variant-selects').find('.pro-option.selected').each(function() {
                optionsList.push($(this).text().trim());
            });
            
            console.log(optionsList)

            var variantsList = $(this).parents('.product__info-container').find('.product-variant-option')
            
            variantsList.each(function() {
                var optionvalue = $(this).text().trim()
                var containsAllValues = optionsList.every(function(value) {
                return optionvalue.includes(value);
            });

            if (containsAllValues) {
                id = $(this).attr('id')
                url = $(this).attr('url')
            }
        })

        $(this).parents('.product__info-container').find('.product-variant-id').attr('value', id)
        $(this).parents('.product-card-wrapper').find('.card__media img').attr('srcset', url)
        }

    })

    // 类型为 select
    $('.product-card-wrapper variant-selects .select__select').change(function() {

        optionsList = []

        $(this).parents('variant-selects').find('.select__select').each(function() {
            optionsList.push($(this).val( ).trim());
        });

        console.log(optionsList)

        var variantsList = $(this).parents('.product__info-container').find('.product-variant-option')

        variantsList.each(function() {
            var optionvalue = $(this).text().trim()

            var containsAllValues = optionsList.every(function(value) {
                return optionvalue.includes(value);
            });


            if (containsAllValues) {
                id = $(this).attr('id')
                url = $(this).attr('url')
                state = $(this).attr('state')
            }
        })

        if(state === 'true') {
            $(this).parents('.product__info-container').find('.product-variant-id').attr('value', id)
            $(this).parents('.product-card-wrapper').find('.card__media img').attr('srcset', url)
            $(this).parents('.product-card-wrapper').find('.product-form__submit').css('display', 'block')
            $(this).parents('.product-card-wrapper').find('.klaviyo-product-container').removeClass('btn-show')
        } else {
            $(this).parents('.product-card-wrapper').find('.product-form__submit').css('display', 'none')
            $(this).parents('.product-card-wrapper').find('.klaviyo-product-container').addClass('btn-show')
        }

        
    })

});